module.exports = __webpack_public_path__ + "static/media/A19.d241fd26.png";